import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import PersonelKartiPage from './PersonelKartiPage';
import YeniPersonelPage from './YeniPersonelPage';

const PersonelListesiPage = () => {
  const { kullanici, yetkiVar, modulYetkileri } = useAuth();
  const [personeller, setPersoneller] = useState([]);
  const [seciliId, setSeciliId] = useState(null);
  const [yeniPersonel, setYeniPersonel] = useState(false);
  const [arama, setArama] = useState('');
  const [departmanFiltre, setDepartmanFiltre] = useState('');
  const [durumFiltre, setDurumFiltre] = useState('');

  const rol = kullanici?.rol;
  const kartAcabilir = true;
  const yeniEkleyebilir = true;

  const yukle = () => axios.get('/api/personel-karti').then(r => setPersoneller(r.data)).catch(console.error);
  useEffect(() => { yukle(); }, []);

  if (yeniPersonel) {
    return <YeniPersonelPage geriDon={() => { setYeniPersonel(false); yukle(); }} />;
  }

  if (seciliId) {
    return <PersonelKartiPage kullaniciId={seciliId} geriDon={() => { setSeciliId(null); yukle(); }} />;
  }

  const departmanlar = [...new Set(personeller.map(p => p.departman).filter(Boolean))].sort();
  const filtrelenmis = personeller.filter(p => {
    const aramaEsles = !arama || (p.ad + ' ' + p.soyad + ' ' + p.email + ' ' + (p.departman || '') + ' ' + (p.pozisyon || '')).toLowerCase().includes(arama.toLowerCase());
    const depEsles = !departmanFiltre || p.departman === departmanFiltre;
    const durumEsles = !durumFiltre || (durumFiltre === 'outsource' ? p.outsource : !p.outsource);
    return aramaEsles && depEsles && durumEsles;
  });

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Personel Listesi</h2>
          <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Personel bilgilerini görüntüleyin ve düzenleyin.</p>
        </div>
        {yeniEkleyebilir && (
          <button className="btn btn-primary" onClick={() => setYeniPersonel(true)}>+ Yeni Personel</button>
        )}
      </div>

      <div className="stats-grid" style={{ marginBottom: '1.5rem' }}>
        <div className="stat-kart"><div className="stat-sayi">{personeller.length}</div><div className="stat-etiket">Toplam Personel</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--mavi)' }}>{personeller.filter(p => p.outsource).length}</div><div className="stat-etiket">Outsource</div></div>
        <div className="stat-kart"><div className="stat-sayi" style={{ color: 'var(--yesil)' }}>{personeller.filter(p => !p.outsource).length}</div><div className="stat-etiket">Dahili</div></div>
        <div className="stat-kart"><div className="stat-sayi">{departmanlar.length}</div><div className="stat-etiket">Departman</div></div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)' }}>
          <input type="text" placeholder="İsim, email, departman ara..." value={arama} onChange={e => setArama(e.target.value)} style={{ width: '100%', maxWidth: '360px' }} />
        </div>

        {filtrelenmis.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Personel bulunamadı.</div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead>
                <tr><th>Personel</th><th>Pozisyon</th><th>Departman</th><th>Yönetici</th><th>Durum</th></tr>
              </thead>
              <tbody>
                {filtrelenmis.map(p => (
                  <tr key={p.id}
                    onClick={() => kartAcabilir && setSeciliId(p.id)}
                    style={{ cursor: kartAcabilir ? 'pointer' : 'default' }}
                  >
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div className="avatar" style={{ width: '32px', height: '32px', fontSize: '12px' }} data-harf={p.ad[0] || '?'}>{p.ad[0]}{p.soyad[0]}</div>
                        <div>
                          <div style={{ fontWeight: '500', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><span>{p.ad} {p.soyad}</span><span style={{ color: 'var(--mavi)', fontSize: '16px' }}>→</span></div>
                          <div style={{ fontSize: '12px', color: 'var(--yazi-ikincil)' }}>{p.email}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ fontSize: '13px' }}>{p.pozisyon || '—'}</td>
                    <td style={{ fontSize: '13px' }}>{p.departman || '—'}</td>
                    <td style={{ fontSize: '13px' }}>{p.yonetici_ad ? p.yonetici_ad + ' ' + p.yonetici_soyad : '—'}</td>
                    <td>
                      {p.outsource ? <span className="badge badge-bekliyor">Outsource</span> : <span className="badge badge-tamamlandi">Dahili</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default PersonelListesiPage;
